import { render } from "./WCActiveOrderTypeBadgeModern.vue?vue&type=template&id=00fac08c&scoped=true"
import script from "./WCActiveOrderTypeBadgeModern.vue?vue&type=script&lang=js"
export * from "./WCActiveOrderTypeBadgeModern.vue?vue&type=script&lang=js"

import "./WCActiveOrderTypeBadgeModern.vue?vue&type=style&index=0&id=00fac08c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fac08c"]])

export default __exports__